import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import UserAvatar, { UserAvatarProps } from 'core/UserAvatar';

import ChatMessagePatientFormContent from './ChatMessagePatientFormContent';

const styles = ({
  palette: {
    text,
    common: { white },
  },
  spacing: { unit },
  custom: {
    palette: { colorGrayishBlue, colorMessageBubble },
  },
}: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: unit * 2,
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      '&$outbound': {
        justifyContent: 'flex-end',
      },
    },
    messageWrapper: {
      backgroundColor: colorGrayishBlue,
      position: 'relative',
      border: '1px',
      borderRadius: '15px 15px 15px 0px',
      color: text.primary,
      display: 'flex',
      flexDirection: 'column',
      fontWeight: 500,
      marginLeft: unit / 2,
      marginRight: 0,
      maxWidth: '80%',
      padding: '10px 15px',
      '&$outbound': {
        backgroundColor: colorMessageBubble,
        borderRadius: '15px 15px 0px 15px',
        color: white,
        alignItems: 'flex-end',
        marginLeft: 0,
        marginRight: `${unit / 2}px`,
      },
    },
    pullBottom: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    outbound: {},
    primary: {},
    '@keyframes blink': {
      '50%': {
        transform: 'scale(1.5)',
      },
    },
  });

export interface ChatMessagePatientFormProps extends WithStyles<typeof styles> {
  resourceId: string;
  patientId?: string;
  interlocutor: UserAvatarProps['user'];
}

const ChatMessagePatientForm: React.FC<ChatMessagePatientFormProps> = ({
  classes,
  resourceId,
  interlocutor,
  patientId,
}) => (
  <div className={classes.root}>
    <div className={classes.wrapper}>
      <div className={classes.pullBottom}>
        <UserAvatar user={interlocutor} size="small" />
      </div>
      <div className={classes.messageWrapper}>
        <ChatMessagePatientFormContent patientFormId={resourceId} />
      </div>
    </div>
  </div>
);

export default withStyles(styles, { name: 'LumaChatMessagePatientForm' })(ChatMessagePatientForm);
